module.exports = __webpack_public_path__ + "images/kihnu/kihnu 1024.png";